module.exports = "/images/error.svg?9b4055abc062a7523c144301ae604a9a";